import * as React from 'react';
import { cn } from '@/lib/utils';

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  hint?: string;
  'data-test-id'?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, hint, 'data-test-id': dataTestId, ...props }, ref) => {
    return (
      <div className="space-y-1" data-test-id="textarea-wrapper">
        <textarea
          className={cn(
            'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
            error && 'border-destructive focus-visible:ring-destructive',
            className
          )}
          ref={ref}
          data-test-id={dataTestId || 'textarea'}
          {...props}
        />
        {error && (
          <p className="text-sm text-destructive" data-test-id="textarea-error">
            {error}
          </p>
        )}
        {hint && !error && (
          <p
            className="text-sm text-muted-foreground"
            data-test-id="textarea-hint"
          >
            {hint}
          </p>
        )}
      </div>
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
